// extracted by mini-css-extract-plugin
module.exports = {"input":"ForgotPassword_input__1XrjE","focused":"ForgotPassword_focused__1SlRc","invalid":"ForgotPassword_invalid__3_wiL","valid":"ForgotPassword_valid__ZSBxp"};